




























import {Component, Vue} from 'vue-property-decorator';
import {Dialog, hideDialog, trainStore} from '@/data/train-store';
import {Observer, observer} from 'mobx-vue';
import {action} from 'mobx';


@Observer
@Component
export default class Dialogs extends Vue {
  private model = true;
  private value = '';
  private store = trainStore;
  private NO_DIALOG = Dialog.NONE;

  private onDialogCancel() {
    hideDialog();
  }

  private onDialogSave() {
    hideDialog(this.value);
  }

  private onInputChange(value: any) {
    this.value = value || '';
  }
}
